import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Intersection/IntersectionUsage.mdx";

import Examples from "../../Docs/Components/Intersection/IntersectionExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Intersection"
            description="Utility used to detect when your elements are clipped by the browser."
            apiSources={["azure-devops-ui/Components/Intersection/Intersection.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;